import React, { useEffect, useState } from 'react';
import { getLogos } from '../utils/firestoreService';

export const BrandsCarousel = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const data = await getLogos();
        // Fallback en caso de que aún no haya logos en DB
        if (data.length === 0) {
          setBrands([
            { name: 'Mattel', url: '/logos/baby.avif' },
            { name: 'Hasbro', url: '/logos/barbie.avif' },
            { name: 'Fisher-Price', url: '/logos/fisher.avif' },
            { name: 'Barbie', url: '/logos/hasbro.avif' },
            { name: 'Hot Wheels', url: '/logos/hotwheels.avif' },
            { name: 'Play-Doh', url: '/logos/monopoly.avif' },
            { name: 'Nerf', url: '/logos/pollypocket.avif' },
          ]);
        } else {
          setBrands(data);
        }
      } catch (error) {
        console.error('Error fetching logos:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBrands();
  }, []);

  // Duplicamos el array para lograr el efecto infinito suave
  const infiniteBrands = [...brands, ...brands];

  if (loading) return null;

  return (
    <div className="w-full bg-slate-50 py-10 overflow-hidden border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6 text-center">
        <h3 className="text-2xl font-fredoka font-bold text-[#1A1A2E]">
          Las Mejores Marcas
        </h3>
      </div>
      <div className="relative w-full flex overflow-hidden group">
        <div className="flex animate-marquee group-hover:pause whitespace-nowrap">
          {infiniteBrands.map((brand, index) => (
            <div
              key={index}
              className="flex items-center justify-center mx-8 min-w-[150px] md:min-w-[200px]"
            >
              <div className="opacity-60 hover:opacity-100 transition-opacity duration-300">
                <img src={brand.imageUrl || brand.url} alt={brand.name} className="h-24 md:h-32 w-auto object-contain" />
              </div>
            </div>
          ))}
        </div>
        <div className="flex animate-marquee group-hover:pause whitespace-nowrap absolute top-0">
          {infiniteBrands.map((brand, index) => (
            <div
              key={index + infiniteBrands.length}
              className="flex items-center justify-center mx-8 min-w-[150px] md:min-w-[200px]"
            >
              <div className="opacity-60 hover:opacity-100 transition-opacity duration-300">
                <img src={brand.imageUrl || brand.url} alt={brand.name} className="h-24 md:h-32 w-auto object-contain" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .pause {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};
